import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {
    AddDepartmentById,
    ListUsersDepartment,
    RemoveUserFromDepartment
} from "../../../../reduxToolkit/Department/DepartmentApi";
import {useTranslation} from "react-i18next";
import {errorMsg, userListToLabelEmailPhoneValue} from "../../../../Apis/functions";
import {useEffect, useState} from "react";
import {PersonChipBlack} from "../../../../components/buttons/IconButtons";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const ManageEmployeeDepartmentApp = ({ onHide, selectedId, setModified }) => {
    const dispatch = useDispatch();
    const {t} = useTranslation(); // Initialize the translation function
    const [results, setResults] = useState([]);

    useEffect(() => {
        if(selectedId) getData();
    }, [selectedId])

    const getData = () => {
        dispatch(ListUsersDepartment(selectedId)).then(
            ({payload: {data: {success, data },},}) =>
            {
                if (success === true) {
                    setResults(userListToLabelEmailPhoneValue(data || [], "userId", false, PersonChipBlack))
                }
            },
        );
    }

    const handleDelete = (dId) => {
        const data = [dId];
        dispatch(RemoveUserFromDepartment(data)).then(({payload: {data: {success, code},},}) => {
                if (success === true) {
                    setModified(true);
                    getData();
                }else errorMsg(code)
            },
        );
    };

    /**
     * Handles the addition of selected users to the department.
     * Dispatches an action to update the department with new user IDs.
     */
    const handleAdd = (items) => {
        const ids = items.map((item) => item.id);
        const data = {
            id: selectedId,
            userids: ids,
        };
        dispatch(AddDepartmentById(data)).then(({payload: {data: {success},},}) => {
                if (success === true) {
                    toast.success(t('has_been_added_successfully')); // Show success message
                    setModified(true);
                    onHide();
                }
            },
        );
    };

    return {
        handleDelete,
        handleAdd,
        selectedEmployee: results,
    };
};
